/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_Total_RevenueInputs */

const en_admin_analyze_allocations_total_revenue = /** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Revenue`)
};

const de_admin_analyze_allocations_total_revenue = /** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtumsatz`)
};

const es_admin_analyze_allocations_total_revenue = /** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos totales`)
};

const fr_admin_analyze_allocations_total_revenue = /** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenus totaux`)
};

/** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */
const it_admin_analyze_allocations_total_revenue = en_admin_analyze_allocations_total_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_total_revenue = en_admin_analyze_allocations_total_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */
const pl_admin_analyze_allocations_total_revenue = en_admin_analyze_allocations_total_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */
const hu_admin_analyze_allocations_total_revenue = en_admin_analyze_allocations_total_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_Total_RevenueInputs) => LocalizedString} */
const ro_admin_analyze_allocations_total_revenue = en_admin_analyze_allocations_total_revenue;

/**
* | output |
* | --- |
* | "Total Revenue" |
*
* @param {Admin_Analyze_Allocations_Total_RevenueInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_total_revenue = /** @type {((inputs?: Admin_Analyze_Allocations_Total_RevenueInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_Total_RevenueInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_total_revenue(inputs)
	if (locale === "de") return de_admin_analyze_allocations_total_revenue(inputs)
	if (locale === "es") return es_admin_analyze_allocations_total_revenue(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_total_revenue(inputs)
	if (locale === "it") return it_admin_analyze_allocations_total_revenue(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_total_revenue(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_total_revenue(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_total_revenue(inputs)
	return ro_admin_analyze_allocations_total_revenue(inputs)
});
export { admin_analyze_allocations_total_revenue as "admin.analyze.allocations.total_revenue" }